import React from "react";
import PropTypes from "prop-types";
import { change, Field } from "redux-form";
import { connect } from "react-redux";
import { DashedSeparator } from "MODULES/shared/components";
import DoNotDoBusinessWarning from "MODULES/companies/shared/components/DoNotDoBusinessWarning";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import ShippingFields from "MODULES/Orders/shared/ShippingFields";
import DetailFields from "MODULES/PurchaseOrders/shared/DetailFields";
import CompanyAddressWarning from "MODULES/shared/components/CompanyAddressWarning";
import ActiveDemeritCompanyWarning from "MODULES/companies/shared/components/ActiveDemeritCompanyWarning";
import BioHazmatWarning from "MODULES/PurchaseOrders/shared/BioHazmatWarning";
import {
  FOB,
  PAYMENT_TERMS,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIPPING_ADDRESS,
  SHIPPING_METHOD,
  SHIPPING_TYPE,
  SHIP_TO_ADDRESS_PHONE
} from "APP_ROOT/constants";
import { Col } from "react-bootstrap";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import validate from "./validate";

const FORM_NAME = "createPurchaseOrder";

export class Form extends React.Component {
  setPaymentTerms = val => {
    this.props.setPurchaseOrder(val);
  };

  render() {
    const {
      selectedBuyer,
      company,
      getFieldValue,
      part,
      setCompany
    } = this.props;
    const invalidCompany =
      company &&
      (!company.primary_physical_address || !company.billing_address);

    return (
      <AppForm {...this.props} disabled={invalidCompany} modal={false}>
        <AppForm.Body>
          <DoNotDoBusinessWarning company={company} />
          <CompanyAddressWarning company={company} />
          <ActiveDemeritCompanyWarning company={company} />
          <DetailFields
            setPaymentTerms={this.setPaymentTerms}
            selectedBuyer={selectedBuyer}
            formName={FORM_NAME}
            setSelectedCompany={setCompany}
          />
          <DashedSeparator />
          <h2>Shipping</h2>
          <div className="row row-col-gutters-half">
            <Col md={6}>
              <div className="form-group">
                <Field
                  name={FOB}
                  component={FormInput}
                  label={FOB.toUpperCase()}
                  required
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="form-group">
                <Field
                  name="ship_date"
                  component={FormInput}
                  type="date"
                  label="Ship Date"
                />
              </div>
            </Col>
          </div>
          <ShippingFields
            formName={FORM_NAME}
            path={SHIPPING_ADDRESS}
            shippingFields={[
              SHIPPING_TYPE,
              SHIP_TO_COMPANY_ID,
              SHIP_TO_COMPANY_ADDRESS_ID,
              SHIP_TO_ADDRESS_PHONE
            ]}
            setTenantAccount
            shippingMethod={SHIPPING_METHOD}
            shippingAddressField={SHIPPING_ADDRESS}
          >
            <BioHazmatWarning
              parts={[part]}
              shippingType={getFieldValue(SHIPPING_TYPE)}
            />
          </ShippingFields>
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  company: PropTypes.instanceOf(Object).isRequired,
  part: PropTypes.shape({}),
  setPurchaseOrder: PropTypes.func.isRequired,
  selectedBuyer: PropTypes.instanceOf(Object),
  setCompany: PropTypes.func.isRequired
};

export default connect(undefined, dispatch => ({
  setPurchaseOrder: val => dispatch(change(FORM_NAME, PAYMENT_TERMS, val))
}))(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/PurchaseOrders/Create/Form.jsx